<ndt-tile-view
  [canRefresh]="false"
  [callState]="tile?.callState"
  [isEditing]="isEditing"
  [isFullscreen]="isFullscreen"
  [tileConfig]="tileConfig"
  [showHeader]="showHeader"
  (configureParameters)="onConfigureParameters()"
  ndtTileContainer
  >
  <p tileheadername>{{ tileConfig.dashboardTileLayoutConfiguration.name }}</p>
  <div tileInfo>
    <div class="clock-display" [ngClass]="getFontSizeClass()">
      <div>{{ currentTime | date : 'h:mma' }}</div>
      @if (tileData?.data.showDate) {
        <div>{{ currentTime | date : 'shortDate' }}</div>
      }
    </div>
  </div>
  <ndt-tile-parameters
    [tileConfig]="tileConfig"
    [formService]="formService"
    *ndtTileParametersDef
    tileParametersList
  ></ndt-tile-parameters>
</ndt-tile-view>
